import Image from 'next/image';
import { motion } from 'framer-motion';

export type DetailError = {
    loc: string[];
    msg: string;
    type: string;
    field?: string;
};

export interface ErrorMessage {
    message?: string;
    errors?: DetailError[];
    field?: string;
}

export default function ErrorBox({ message, errors, field }: ErrorMessage) {
    const extractErrorsForField = (): DetailError[] => {
        if (!errors || !field) return [];
        return errors.filter((error) => error.field === field);
    };

    const fieldErrors = extractErrorsForField();

    if (field && fieldErrors.length === 0) return null;
    if (!field && !message && (!errors || errors.length === 0)) return null;

    return field ? (
        <motion.div
            key={`fieldErrorBox-${field}`}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="relative flex items-center justify-center bg-color-white-base w-full z-5 fieldErrorStyle"
        >
            <div className="flex-grow">
                <div className="font-notojp font-medium text-color-error text-xs whitespace-pre-wrap">
                    <ul className="list-disc list-inside space-y-1">
                        {fieldErrors.map((error, idx) => (
                            <li key={idx}>{error.msg}</li>
                        ))}
                    </ul>
                </div>
            </div>
        </motion.div>
    ) : (
        <motion.div
            key="errorBox"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="relative flex items-center justify-center bg-color-white-base border border-color-error py-1 lg:py-3 mt-2 mb-5 w-full z-5"
        >
            <div className="absolute -mt-7 top-0 left-0">
                <Image src="/images/common/error.svg" width={46} height={46} alt="" quality={100} className="pl-2" />
            </div>
            <div className="flex-grow ml-2 min-w-0 max-w-full">
                <div className="font-notojp font-medium lg:font-bold text-color-error tracking-wider text-[10px] lg:text-xs whitespace-pre-wrap py-2 lg:py-0">
                    {message && (!errors || errors.length === 0) ? (
                        message
                    ) : (
                        <ul className="list-disc list-inside space-y-1">
                            {errors?.map((error, idx) => <li key={idx}>{error.msg}</li>)}
                        </ul>
                    )}
                </div>
            </div>
        </motion.div>
    );
}
